const TOKEN_KEY = 'agilizaos_access_token';
const USER_KEY = 'agilizaos_user';

export type StoredUsuario = {
  id: string;
  nome: string;
  email: string;
  organizacaoId: string;
  organizacao: { id: string; nome: string };
  perfis: string[];
  filialId: string | null;
  filial: { id: string; nome: string } | null;
  regiaoId?: string | null;
  escopoFilialIds?: string[];
  permissoesExtras?: Record<string, boolean>;
  primeiroAcesso?: boolean;
  impersonatedBy?: string;
};

const ADMIN_TOKEN_KEY = 'agilizaos_admin_token';
const ADMIN_USER_KEY = 'agilizaos_admin_user';

export function saveAdminSession() {
  const token = localStorage.getItem('agilizaos_access_token');
  const user = localStorage.getItem('agilizaos_user');
  if (token) sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
  if (user) sessionStorage.setItem(ADMIN_USER_KEY, user);
}

export function getAdminSession(): { token: string; user: StoredUsuario } | null {
  const token = sessionStorage.getItem(ADMIN_TOKEN_KEY);
  const raw = sessionStorage.getItem(ADMIN_USER_KEY);
  if (!token || !raw) return null;
  try {
    return { token, user: JSON.parse(raw) as StoredUsuario };
  } catch {
    return null;
  }
}

export function clearAdminSession() {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  sessionStorage.removeItem(ADMIN_USER_KEY);
}

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUser(): StoredUsuario | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredUsuario;
  } catch {
    return null;
  }
}

export function persistSession(accessToken: string, usuario: StoredUsuario) {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(USER_KEY, JSON.stringify(usuario));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
